import { create } from "zustand";
import { createConnectStore, ConnectStoreSlice } from "./connect.store";

export type ConnectStoreUnion = ConnectStoreSlice;

export const useConnectStore = create<ConnectStoreUnion>((...args) => ({
	...createConnectStore(...args),
}));
